import api from "./api";

export default class ResidencyPriceApi {
  static async List(data) {
    return await api.get(`residency-price`, data);
  }

  static async Patch(data) {
    return await api.patch(`residency-price`, data);
  }
}
